import "../scss/main.scss";
import { initSmoothScroll } from "./components/smooth-scroll";
import { initRelatedProducts } from "./components/related-products";
import { initWooFilters } from "./components/woo-filters";
import { initSingleProject } from "./components/single-project";
import { headerInit, initMobileMenu } from "./components/header";
import { initSpacesSlider } from "./components/spaces-slider";
import { initHotelsProductsSlider } from "./components/hotels-products-sliders";
import { initCategoriesSlider } from "./components/categories-slider";
import projectsFilters from "./components/projectsFilters";
import loadMoreImages from "./components/loadMoreimages";
import Hotspots from "./components/hotspots";
import LazyLoad from "vanilla-lazyload";
import loadMoreProducts from "./components/LoadMoreProducts";
import { initVideoMute } from "./components/video-mute";

// Cache selectors for performance
const selectors = {
  landingHero: document.querySelector(".landing-hero"),
  relatedProducts: document.querySelector(".more-categories__swiper") || document.querySelector(".related-products__swiper"),
  wooFilters: document.querySelector(".woo-filters"),
  singleProject: document.querySelector(".single-projects"),
  spacesSlider: document.querySelector(".explore-spaces__swiper"),
  hotelsSlider: document.querySelector(".hotels-products__swiper"),
  categoriesSlider: document.querySelector(".categories-slider__swiper"),
  hotspots: document.querySelector(".space-image__hotspot"),
  projectsFilters: document.querySelector(".projects-filters"),
  loadMoreImages: document.querySelector(".woo-archive__grid"),
  loadMoreProducts: document.querySelector("#load-more-btn"),
};

window.addEventListener("DOMContentLoaded", () => {
  // Initialize global
  initSmoothScroll();
  headerInit();
  initMobileMenu();

  // Initialize lazy loading
  const lazyLoadInstance = new LazyLoad({
    elements_selector: "[data-lazy]",
  });
  window.lazyLoadInstance = lazyLoadInstance; // Expose for debugging

  // Initialize components only if their elements exist
  if (selectors.landingHero) initVideoMute();
  if (selectors.relatedProducts) initRelatedProducts();
  if (selectors.wooFilters) initWooFilters();
  if (selectors.singleProject) initSingleProject();
  if (selectors.spacesSlider) initSpacesSlider();
  if (selectors.hotelsSlider) initHotelsProductsSlider();
  if (selectors.categoriesSlider) initCategoriesSlider();
  if (selectors.hotspots) Hotspots();
  if (selectors.projectsFilters) projectsFilters();
  if (selectors.loadMoreImages) loadMoreImages();
});

window.addEventListener("load", () => {
  if (selectors.loadMoreProducts) loadMoreProducts();
});
